<template>
  <div
    class="container col-lg-8 col-md-8 partner-edit-subscription pb-4 mb-4"
  >
    <EditPartnerSubscription @submit="editPartnerSubscription" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import EditPartnerSubscription from "@/containers/Partner/EditPartnerSubscription";

export default {
  name: "EditPartnerSubscriptionPage",
  components: { EditPartnerSubscription },

  methods: {
    ...mapActions(["updatePartnerSubscription"]),
    editPartnerSubscription(data) {
      this.updatePartnerSubscription(data);
    },
  },
};
</script>
